// extracted by mini-css-extract-plugin
export default {"stickyArticleHeader":"k_T","stickyArticleHeaderContainer":"k_V","stickyArticleHeaderButton":"k_W","text_left":"k_X","progressContainer":"k_Y","progressBar":"k_Z"};